module.exports = __webpack_public_path__ + "media/images/tour/d/ko-d4893b380e16df7fa0b0ca26fcc6e8aa.png";